import type { MedProfile } from './hook/types';

export const MedicationProfileSteps = Object.freeze({
  FULL_LIST: 'fullList',
  NEW_MEDICATION: 'newMedication',
  MEDICATION_DETAIL: 'medicationDetail',
  MEDICATION_CREATE_DETAIL: 'createMedicationDetail',
});

export const MedicationProfileStates = Object.freeze({
  FINALISED: 'finalised',
  IN_PROGRESS: 'in progress',
  ENTERED_IN_ERROR: 'entered in error',
  CONSUMER_CREATED: 'consumer created',
});
export const defaultMedSectionBreak = 'Regular medicines';

export type MedProfileForm = Pick<
  MedProfile,
  'appointments' | 'medSections' | 'pdfOptions'
>;
